import React from 'react';
import './Inventory.css';

const Inventory = () => {
    return (
        <div className="py-5">
            <h1 className="text-center mt-5 fs-1 fw-bold">
                THANK YOU FOR CHOOSING{' '}
                <span className="featured-text">FITLANG</span>
            </h1>
            <h4 className="text-center mt-5">You will get an Email soon</h4>
        </div>
    );
};

export default Inventory;
